/**
 * 160: the legal documents the platform publishes.
 *
 * One home for the two kinds and their titles, so a screen never spells a kind as a string literal
 * — the address, the fetch path and the heading all derive from the same pair.
 */

export const LEGAL_DOCUMENT_KINDS = ['terms_of_service', 'privacy_policy'] as const;

export type LegalDocumentKind = (typeof LEGAL_DOCUMENT_KINDS)[number];

export interface LegalDocument {
  id: string;
  kind: LegalDocumentKind;
  version: string;
  body_html: string;
  published_at: string;
}

export const LEGAL_DOCUMENT_TITLES: Record<LegalDocumentKind, string> = {
  terms_of_service: 'Terms of Service',
  privacy_policy: 'Privacy Policy',
};

/**
 * The public addresses. `/terms` is kept as an alias of the terms of service because feature 153
 * shipped that address into the booking form, and a link a customer may already have followed must
 * not start 404ing (US2 AC3).
 */
export const LEGAL_DOCUMENT_PATHS: Record<LegalDocumentKind, string> = {
  terms_of_service: '/terms-of-service',
  privacy_policy: '/privacy-policy',
};
